import { useTranslation } from 'react-i18next';
import { Zap, MessageSquare, Tag } from 'lucide-react';

const features = [
  {
    titleKey: 'LANDING_WORKFLOW_FEATURE1_TITLE',
    descKey: 'LANDING_WORKFLOW_FEATURE1_DESC',
    icon: Zap,
    colorClass: 'bg-sky-blue/15 text-sky-blue',
  },
  {
    titleKey: 'LANDING_WORKFLOW_FEATURE2_TITLE',
    descKey: 'LANDING_WORKFLOW_FEATURE2_DESC',
    icon: MessageSquare,
    colorClass: 'bg-light-blue/15 text-light-blue',
  },
  {
    titleKey: 'LANDING_WORKFLOW_FEATURE3_TITLE',
    descKey: 'LANDING_WORKFLOW_FEATURE3_DESC',
    icon: Tag,
    colorClass: 'bg-selise-blue/15 text-selise-blue',
  },
];

export const IntegratedWorkflow = () => {
  const { t } = useTranslation();

  return (
    <section className="bg-oxford-blue py-24 px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Text + Features */}
          <div>
            <h2 className="text-4xl font-bold tracking-tight text-white font-aptos sm:text-5xl mb-6">
              {t('LANDING_WORKFLOW_TITLE')}
            </h2>
            <p className="text-xl text-white font-medium mb-10 leading-relaxed font-open-sans">
              {t('LANDING_WORKFLOW_SUBTITLE')}
            </p>

            <div className="space-y-8">
              {features.map(({ titleKey, descKey, icon: Icon, colorClass }) => (
                <div key={titleKey} className="flex gap-4">
                  <div
                    className={`shrink-0 h-12 w-12 flex items-center justify-center rounded-full ${colorClass}`}
                  >
                    <Icon className="h-6 w-6" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-white mb-2 font-aptos">
                      {t(titleKey)}
                    </h3>
                    <p className="text-white font-open-sans leading-relaxed">
                      {t(descKey)}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <img
              src="/images/why-choose-us.png"
              alt="SELISE Legal Templates integrated workflow illustration"
              loading="lazy"
              className="w-full aspect-[4/5] object-contain"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
